<template>
  <!-- BEGIN pos-counter-sidebar -->
  <div class="pos-counter-sidebar" id="pos-counter-sidebar">
    <!-- Sidebar Header -->
    <SidebarHeader :tableSelected="tableSelected" @posMobileSidebarToggled="$emit('posMobileSidebarToggled')" />

    <!-- Sidebar Body -->
    <SidebarBody :tableSelected="tableSelected" :defaultCrrency="defaultCrrency"
      @removeItem="$emit('removeItem', $event)" @fetchTableByInterval="$emit('fetchTableByInterval', $event)" />

    <!-- Sidebar Footer -->
    <SidebarFooter :tableSelected="tableSelected" :defaultCrrency="defaultCrrency" :vatRate="vatRate"
      :printing="printing" @showCombineTableForm="$emit('showCombineTableForm')" @moveTable="$emit('moveTable')"
      @cleanTable="$emit('cleanTable')" @cancelOrder="$emit('cancelOrder')" @addMoreOrder="$emit('addMoreOrder')"
      @printBill="$emit('printBill')" @showBillForm="$emit('showBillForm')"
      @showShiftCloseForm="$emit('showShiftCloseForm')" @showLinkedKeysForm="$emit('showLinkedKeysForm')"
      @onTableSelected="$emit('onTableSelected', $event)" @showQueueListForm="$emit('showQueueListForm')"
      @showMemberCardForm="$emit('showMemberCardForm')" @showInvoiceListForm="$emit('showInvoiceListForm')" />
  </div>
  <!-- END pos-counter-sidebar -->
</template>

<script>
import SidebarHeader from './SidebarHeader.vue'
import SidebarBody from './SidebarBody.vue'
import SidebarFooter from './SidebarFooter.vue'

export default {
  name: 'PosCounterSidebar',
  components: {
    SidebarHeader,
    SidebarBody,
    SidebarFooter
  },
  props: {
    tableSelected: {
      type: Object,
      default: () => ({})
    },
    posMobileSidebar: {
      type: Boolean,
      default: false
    },
    defaultCrrency: {
      type: String,
      default: ''
    },
    vatRate: {
      type: Number,
      default: 0
    },
    printing: {
      type: Boolean,
      default: false
    }
  }
}
</script>